import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from "src/app/store/reducer";
import { OpenAdvanceSearchModal } from '../../store/actions';
import { AddEntryJvComponent } from '../add-entry-jv/add-entry-jv.component';
import { Tab } from 'src/app/shared/model/tab.model';
import { TabService } from 'src/app/shared/services/tab.service';
@Component({
	selector: 'app-view-jv',
	templateUrl: './view-jv.component.html',
	styleUrls: ['./view-jv.component.scss']
})
export class ViewJvComponent implements OnInit {
	jvArr: any;
	navigationSubscription;
	reInitialise: boolean;
	p;
	innerHeight: string;
	fromRoot = true;
	selector: string = '.main-panel';
	fromIndex: any = 0;
	toIndex: any = 30;
	onSearch;
	onSearchFilter = new Subject<string>();
	isAdvancedSearchOpen: boolean = false;
	currentIndex=0
	@ViewChild('tableHeader', {static:true}) tableHeader : ElementRef
	alljvArr: any;
	advancedSearchSubscription : Subscription;
	duration: any;
	loader: boolean = false;
	queryParams: any;

	constructor(
		private route: ActivatedRoute,
		public commonService: CommonServiceService,
		private store: Store<InitialState>,
		private router: Router,
		private tabService: TabService
	) {
		this.navigationSubscription = this.router.events.subscribe((e: any) => {
			// If it is a NavigationEnd event re-initalise the component
			if (e instanceof NavigationEnd) {
				this.initialiseInvites();
			}
		});
	}

	ngOnInit() {
		let queryParams = JSON.parse(JSON.stringify(this.route.queryParams['value']))
		if (queryParams.account != undefined) {
			localStorage.setItem('activeJVQueryParams',JSON.stringify(queryParams))
		} 
		this.fromIndex = 0;
		queryParams['limit'] = 30;
        queryParams['offset'] = this.fromIndex;
		this.onSearch = ''
        this.search(queryParams)
		this.queryParams = queryParams
		this.reInitialise=true
		this.onSearchFilter.pipe(
			debounceTime(300),
			distinctUntilChanged())
			.subscribe(value => {
			  this.filterData(value)
		});
	}
	initialiseInvites() {
		if (this.reInitialise) {
			this.ngOnInit()
		}
	}

	ngAfterViewInit(){
		this.advancedSearchSubscription = this.commonService.advancedSearch.subscribe(status=>{
			console.log('Is modal opened : ',status)
			this.isAdvancedSearchOpen = status
		})
	}
	openAdvanceSearchModal(){
		this.store.dispatch(new OpenAdvanceSearchModal({status: true,title : 'jv'}));	
	}

	ngOnDestroy() {
		// avoid memory leaks here by cleaning up after ourselves. If we  
		// don't then we will continue to run our initialiseInvites()   
		// method on every navigationEnd event.
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
		if (this.advancedSearchSubscription) {
			this.advancedSearchSubscription.unsubscribe();
		}
	}
	
	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.setHeight(event.target.innerHeight)
	}



	oldSearch(values) {
		this.loader = true;
		this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/jv`, values).subscribe(res => {
			this.jvArr =[]
			this.loader = false;
			this.duration = res['duration']
			this.alljvArr = res['data']
			this.focusOnTableHeader()
			this.currentIndex = 0
			for (let i = 0; i <= 30; i++) {
				const element = this.alljvArr[i];
				if (element != undefined) {
					this.commonService.selectedInput.next(1)
					this.toIndex = i
					this.jvArr.push(element)
				}
			}
			this.setHeight(window.innerHeight)
		})
	}
	async search(values) {
		let reqObj = Object.assign({},values)
		
		this.loader = true;
		let resp = await this.getData(reqObj)
		if(resp){
			this.loader = false;
			this.duration = resp['duration']
			this.alljvArr = resp['data']
			this.jvArr = resp['data']
			this.focusOnTableHeader()
			this.currentIndex = 0
			this.setHeight(window.innerHeight)
			this.commonService.selectedInput.next(1)
		}
		
	}

	getData(values){
		return new Promise(async (resolve, reject) => {
			this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/jv`, values).subscribe(res => {
				resolve(res)
			},err=> {
				resolve(null)
			})
		})
	}

	async onScrollDown(event) {
		this.fromIndex +=30
		// let toIndex = Number(this.toIndex) + 10
		let queryParams = JSON.parse(JSON.stringify(this.queryParams))
		queryParams['limit'] = 30;
		queryParams['offset'] = this.fromIndex;
		let resp = await this.getData(queryParams)
		if(resp){
			this.jvArr = this.jvArr.concat(resp['data'])
			this.setHeight(window.innerHeight)
		}
	  }
	setHeight(height) {
		if (this.jvArr != undefined) {
			if (height == undefined) {
				height = window.innerHeight
			}
			if (this.jvArr.length <= 9) {
				this.innerHeight = 'auto'
			}
			else {
				this.innerHeight = height - 147 + 'px';
			}
		}
	}
	openJV(jv_code){
		if(window.location.protocol != 'file:'){
			let title =''
			let invoiceParts = jv_code.split('-')
			title += invoiceParts[0]
			title +='...'
			title += invoiceParts[invoiceParts.length-1]
			if(jv_code) {
				this.tabService.addTab(
					new Tab(AddEntryJvComponent, `${title}`, { jv_code: jv_code }, jv_code)
					);
				}
		   else {
			window.open(`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/jv/update/${jv_code}`);
		   } 
		}
	}
	

	focusOnTableHeader(){
		if(this.tableHeader != undefined){
			this.tableHeader.nativeElement.focus()
		}
	}
	
	// @HostListener('window:keydown', ['$event'])
	onKeyDown(e: any) {
		console.log('openModalStatus : ' + GlobalVariable.openModalStatus)
		if (GlobalVariable.openModalStatus == false && GlobalVariable.openGlobalSearch == false) {
			if (e.keyCode == 40) {
				e.preventDefault();
				this.moveToNext()
			} else if (e.keyCode === 38) {
				e.preventDefault();
				this.moveToPrev()
			}
		}
	}
	moveToNext(){
		if (document.getElementById(`rowIndex_${this.currentIndex+1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex+1}`).focus()
			this.currentIndex = this.currentIndex+1
		}
	}
	moveToPrev(){
		if (document.getElementById(`rowIndex_${this.currentIndex-1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex-1}`).focus()
			this.currentIndex = this.currentIndex-1
		}
	}
	
	moveToIndex(i){
		document.getElementById(`rowIndex_${i+1}`).focus()
		this.currentIndex = i+1
	}

	  onScrollUp(event) {
	  }


	oldFilterData(value) {
		let tempArr = Object.assign([], this.alljvArr)
		if (value.length >= 3) {
			let lowerCaseFilter = value.toLowerCase()
			let upperCaseFilter = value.toUpperCase()
			this.jvArr = tempArr.filter(
				jvData => {
					if (	(
								jvData.last_updated_by_name != undefined && 
								jvData.last_updated_by_name != null && 
								(	jvData.last_updated_by_name.includes(value) || 
									jvData.last_updated_by_name.includes(upperCaseFilter) ||
									jvData.last_updated_by_name.includes(lowerCaseFilter)
								)
							) ||
							(
								jvData.journal_code != undefined && 
								jvData.journal_code != null && 
								(	jvData.journal_code.includes(value) || 
									jvData.journal_code.includes(upperCaseFilter) ||
									jvData.journal_code.includes(lowerCaseFilter)
								)
							) || 
							(
								jvData.credit_amount != undefined && 
								jvData.credit_amount != null && 
								(	jvData.credit_amount.includes(value) || 
									jvData.credit_amount.includes(upperCaseFilter) ||
									jvData.credit_amount.includes(lowerCaseFilter)
								)
							) ||
							(
								jvData.debit_amount != undefined && 
								jvData.debit_amount != null && 
								(	jvData.debit_amount.includes(value) || 
									jvData.debit_amount.includes(upperCaseFilter) ||
									jvData.debit_amount.includes(lowerCaseFilter)
								)
							)
						) {
						return jvData
					}
					console.log(jvData)
				}
			)
			this.setHeight(window.innerHeight)
		} else{
			this.jvArr = []
			for (let i = 0; i <= 30; i++) {
				const element = this.alljvArr[i];
				if (element != undefined) {
					this.toIndex = i
					this.jvArr.push(element)
				}
			}
			this.setHeight(window.innerHeight)
		}
	}

	async filterData(value) {
        if (value.length >= 0) {
            this.queryParams['freetext'] = value
            let queryParams = JSON.parse(JSON.stringify(this.queryParams))
            this.queryParams = queryParams
			this.fromIndex=0
            queryParams['limit'] = 30;
            queryParams['offset'] = this.fromIndex;
			this.loader = true
            let resp = await this.getData(queryParams)
			this.loader = false
            if(resp){
                this.jvArr = resp['data']
				let firstRow = document.getElementById('rowIndex_1') as HTMLElement
				if(firstRow){
					firstRow.scrollIntoView()
				}

            }
           
        this.setHeight(window.innerHeight)
        } else {
            delete this.queryParams['freetext']
            this.search(this.queryParams)
            this.setHeight(window.innerHeight)
        }
    }

}
